import defaultElementsManager from './defaultItemsManager';

export default defaultElementsManager.items;
